var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-with-decoration"},[_c('img',{staticClass:"title-with-decoration__left",attrs:{"src":_vm.leftImage,"alt":"装饰"}}),_c('span',{staticClass:"title-with-decoration__text"},[_vm._v(_vm._s(_vm.title))]),_c('img',{staticClass:"title-with-decoration__right",attrs:{"src":_vm.rightImage,"alt":"装饰"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }